import { ENV_CONFIG } from 'config/environment';

const BASE = `${ENV_CONFIG.CLOUD_STORAGE.URL}/scampac`;

export const ABOUT_US_IMAGES = {
  spotTheGrift: `${BASE}/spot_the_grift.png`,
  filterSpam: `${BASE}/filter_spam.png`,
  trustedOrgs: `${BASE}/trusted_orgs.png`,
};

export const SHARE_TIPS_TEXT =
  'Hey, just a heads-up! 🚩 Watch out for Scam PACs when donating. They use fake deadlines and super dramatic texts to trick people. The money typically goes to their own team vs. the cause they\'re promoting.\n\nRed flags: No real website, "Match" or "Final notice" gimmicks, Overly emotional\n\nFound this cool site that helps you spot them >> griftalert.org';

export const SPOT_THE_GRIFT = {
  title: 'Spot the grift',
  paragraphs: [
    'When you receive a text asking for a donation, stop before you give. There are tell tale signs that you can watch out for to avoid wasting your money:',
  ],
  listItems: [
    'No public website',
    'Overly urgent and emotional appeals for donations',
    'Fake deadlines or matching challenges',
  ],
  closingParagraph:
    "Watch for the signs and educate your loved ones. Don't let grandma get played. Help her outsmart the grift.",
  buttonLabel: 'SHARE TIPS',
};

export const FILTER_OUT_THE_SPAM = {
  title: 'Filter out the spam',
  paragraphs: [
    "It's tempting to respond or even donate just to make the texts stop — but that's the worst thing you can do. When you engage with or give money through a spam text, you reward the sender and increase the likelihood that your contact information will be shared or sold to additional campaigns and data brokers.",
    'There are a few ways you can cut down on the amount of unwanted spam texts and emails you receive.',
  ],
  buttonLabel: 'LEARN HOW',
};

export const GIVE_ONLY_TO_TRUSTED = {
  title: 'Give only to trusted orgs',
  description:
    'There are so many organizations doing great work. We want to make it easy to fund trusted groups that can turn your generous donations into real impact. You can feel good about making a donation to any of the groups featured here.',
  buttonLabel: 'GIVE SAFELY',
  donateUrl: 'https://app.oath.vote/donate?p=grift-alert&ref=ga-website',
};

const LEARN_HOW_LINKS = {
  iphone: 'https://support.apple.com/guide/iphone/screen-and-filter-texts-iph203ab0be4/ios',
  android: 'https://support.google.com/messages/answer/13973949?hl=en',
  grassrootsAnalytics: 'https://www.grassrootsanalytics.com/california-consumer-privacy-act-ccpa',
  leverage: 'https://leveragedigital.ai/do-not-sell/',
  trueBlue: 'https://trueblueanalytics.org/dont-sell',
  messageDigital: 'https://messagedigital.com/my-data',
  fraiser: 'https://www.fraiser.org/data-request-form',
  ctia: 'https://www.ctia.org/consumer-resources/protecting-yourself-from-spam-text-messages',
} as const;

export const LEARN_HOW_MODAL = {
  title: 'Learn How',
  sections: [
    {
      type: 'paragraph' as const,
      content: 'Filter out spam messages on your phone. Follow these instructions for ',
      links: [
        { label: 'iPhone', url: LEARN_HOW_LINKS.iphone },
        { label: 'Android', url: LEARN_HOW_LINKS.android },
      ],
      contentAfter: '.',
    },
    {
      type: 'list' as const,
      content:
        'Submit "Do Not Share My Information" requests with these vendors to reduce your exposure:',
      items: [
        { label: 'Grassroots Analytics', url: LEARN_HOW_LINKS.grassrootsAnalytics },
        { label: 'Leverage', url: LEARN_HOW_LINKS.leverage },
        { label: 'True Blue', url: LEARN_HOW_LINKS.trueBlue },
        { label: 'Message Digital', url: LEARN_HOW_LINKS.messageDigital },
        { label: 'Fraiser', url: LEARN_HOW_LINKS.fraiser },
      ],
    },
    {
      type: 'paragraph' as const,
      content:
        'Report it - when you receive unwanted spam, you can report it by forwarding to 7726 (SPAM). Visit ',
      links: [{ label: "CTIA's consumer resource page", url: LEARN_HOW_LINKS.ctia }],
      contentAfter: ' for more information.',
    },
  ],
  buttonLabel: 'Close',
};
